import { Avatar } from '@mui/material';
import * as css from './UserAvatar.css';

type UserAvatarProps = {
  src?: string;
  displayName: string;
  isCreator: boolean;
  size?: number;
};

export const UserAvatar = ({
  src,
  displayName,
  isCreator,
  size = 40,
}: UserAvatarProps) => {
  return (
    <Avatar
      src={src}
      alt={displayName}
      className={css.avatar}
      sx={{ width: size, height: size }}
    >
      {isCreator ? '👑' : displayName?.charAt(0)?.toUpperCase() || 'U'}
    </Avatar>
  );
};
